import {ReactComponent as AddIcon} from "./plus-large.svg";

const Addicon = () => {
    return (
        <div><AddIcon className='icon' /></div>
    )
}
export default Addicon
